import { Routes, Route } from 'react-router-dom';
import Hisaab from './accounts/Hisaab';
import DriverPayments from './accounts/DriverPayments';
import Outstandings from './accounts/Outstandings';
import VendorLedger from './accounts/VendorLedger';
import WhatsAppDispatch from './accounts/WhatsAppDispatch';
import Reports from './accounts/Reports';
import RepairMaintenance from './accounts/RepairMaintenance';

const Accounts = () => {
  return (
    <div className="space-y-6">
      <Routes>
        <Route path="/" element={<Hisaab />} />
        <Route path="/hisaab" element={<Hisaab />} />
        <Route path="/driver-payments" element={<DriverPayments />} />
        <Route path="/outstandings" element={<Outstandings />} />
        <Route path="/vendor-ledger" element={<VendorLedger />} />
        <Route path="/whatsapp" element={<WhatsAppDispatch />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/repair-maintenance" element={<RepairMaintenance />} />
      </Routes>
    </div>
  );
};

export default Accounts;
